import {Attendee} from '../attendee/attendee.model';

export class Event {
  id: string = '';
  title: string = '';
  description: string = '';
  comments: string = '';
  address: string = '';
  startDate: Date = new Date();
  endDate: Date = new Date();
  active: boolean = false;
  full: boolean = false;
  minPerson: number = 0;
  maxPerson: number = 0;
  price: number = 0;
  createdAt: Date = new Date();
  updatedAt: Date = new Date();
  companyIds: string[] = [];
  vetoedCompanyIds: string[] = [];

  // These fields are for marking the attendee preference
  selected: boolean;
  asLeader: boolean;

  static fromJSON(data): Event {
    let dates = {
      startDate: new Date(data.startDate),
      endDate: new Date(data.endDate),
      createdAt: new Date(data.createdAt),
      updatedAt: new Date(data.updatedAt),
    };
    return Object.assign(new Event(), data, dates);
  }

  // hasCompanies returns true if ANY of the companies is already attending the event
  hasCompanies(companyIds: string[]): boolean {
    if (!this.companyIds) {
      return false;
    }
    for (let companyId of companyIds) {
      if (this.companyIds.indexOf(companyId) !== -1) {
        return true;
      }
    }
    return false;
  }

  companyAllowed(companyId: string): boolean {
    if (!this.vetoedCompanyIds) {
      return true;
    }
    return this.vetoedCompanyIds.indexOf(companyId) === -1;
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/event/event.model.ts
 **/